import { render } from "./TimelineContent.vue?vue&type=template&id=2a54afd5"
import script from "./TimelineContent.vue?vue&type=script&lang=js"
export * from "./TimelineContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__